export default "__VITE_ASSET__BLphY5L3__"